"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeLog = exports.LogKeys = exports.IkeLogStreamType = exports.IkeLogType = void 0;
exports.LOGKEY = LOGKEY;
var tslib_1 = require("tslib");
var bblog_1 = require("bblog");
var bblog_stream_console_1 = require("bblog-stream-console");
var log_streams_1 = require("./log.streams");
var log_types_1 = require("./log.types");
Object.defineProperty(exports, "IkeLogType", { enumerable: true, get: function () { return log_types_1.IkeLogType; } });
var log_streams_2 = require("./log.streams");
Object.defineProperty(exports, "IkeLogStreamType", { enumerable: true, get: function () { return log_streams_2.IkeLogStreamType; } });
exports.LogKeys = {
    CONSOLE: 'console',
    TYPE: 'type',
    STREAM: 'stream',
    LEVEL: 'level',
    CONFIG: 'config'
};
var REQUIRED_KEYS = [exports.LogKeys.LEVEL, exports.LogKeys.STREAM];
function LOGKEY(type, key) {
    return ['log', type, key].join('.');
}
tslib_1.__exportStar(require("bblog"), exports);
var FACTORIES = {};
var IkeLog = /** @class */ (function (_super) {
    tslib_1.__extends(IkeLog, _super);
    function IkeLog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IkeLog.create = function (config, type, options) {
        var requiredKeys = REQUIRED_KEYS.map(function (k) { return LOGKEY(type, k); });
        if (config.requires(requiredKeys)) {
            throw new Error("Unable to create logger ".concat(type, " missing keys: ") + config.missing(requiredKeys).join(','));
        }
        var streams = [];
        var logLevel = config.getDefaultNumber(LOGKEY(type, exports.LogKeys.LEVEL), 10);
        var logStreamType = config.getString(LOGKEY(type, exports.LogKeys.STREAM));
        var consoleEnabled = LOGKEY(type, exports.LogKeys.CONSOLE);
        if (config.getBoolean(consoleEnabled) && logStreamType !== log_streams_1.IkeLogStreamType.CONSOLE) {
            streams.push(ConsoleStreamFactory.create(logLevel));
        }
        if (logStreamType != null) {
            var configKey = LOGKEY(type, exports.LogKeys.CONFIG);
            var logConfig = config.get(configKey);
            var factory = FACTORIES[logStreamType];
            if (factory == null) {
                throw new Error("Unable to construct log stream: ".concat(logStreamType, " please import @ikegps/core-log-").concat(logStreamType));
            }
            var logStream = factory.create(logLevel, logConfig);
            streams.push(logStream);
        }
        var logger = IkeLog.createLogger({
            name: options.name,
            streams: streams,
            hostname: options.hostname,
            keys: options.keys
        });
        config.register(logger);
        return logger;
    };
    IkeLog.register = function (factory) {
        FACTORIES[factory.type] = factory;
    };
    return IkeLog;
}(bblog_1.Log));
exports.IkeLog = IkeLog;
var ConsoleStreamFactory = {
    type: log_streams_1.IkeLogStreamType.CONSOLE,
    create: function (level) { return new bblog_stream_console_1.ConsoleLogStream(level); }
};
IkeLog.register(ConsoleStreamFactory);
//# sourceMappingURL=index.js.map